import { render } from "./verifyDealer.vue?vue&type=template&id=2845e05e"
import script from "./verifyDealer.vue?vue&type=script&lang=js"
export * from "./verifyDealer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__